module.exports = __webpack_public_path__ + "media/components/assets/img/bg/footer-bottom-right-7136e6f9d91863c1f5741cb6849e14cb.svg";